import React from 'react';
import { motion } from 'framer-motion';
import './Hospitality.css';

const Hospitality: React.FC = () => {
  return (
    <div className="venture-page">
      <div className="venture-container">
        {/* Main Content */}
        <div className="venture-content">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="venture-main-section"
          >
            <div className="venture-header">
              <div className="venture-header-background"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/hospitality.jpg)` }}
              >
                <div className="venture-header-overlay">
                  <h2 className="section-main-title">Hospitality</h2>
                </div>
              </div>
            </div>
            <div className="venture-content-container">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="venture-text-section"
              >
                <div className="venture-text-content">
                  <div className="venture-text">
                    <p>
                    Ansuvara Group has a strong foothold in the hospitality industry with a portfolio of premier properties.
                    The Group’s latest asset, Bagaincha Resort & Spa, is a luxury resort in Pokhara that offers a seamless
                    blend of natural beauty, wellness, and refined guest experiences. Previously, the Group owned the
                    Pokhara Boutique Hotel, contributing .Building on this foundation, Ansuvara Group is currently
                    developing 31 Park Hotel in Lakeside, Pokhara.A contemporary city hotel focused on delivering
                    exceptional comfort and accessibility in one of the area’s most vibrant locations.
                    </p>
                    
                  </div>
                </div>
              </motion.div>
            </div>

             {/* Property Displays Section */}
             <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
              className="property-displays-section"
            >
              <div className="property-displays-container">
                <div className="property-cards-grid">
                  {/* Bagaincha Resort & Spa */}
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.3 }}
                    className="property-card"
                  >
                    <a 
                      href="https://bagaincha.com" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="property-card-link"
                    >
                      <div className="property-card-image">
                        <div 
                          className="property-card-bg"
                          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/bagaincha.jpeg)` }}
                        ></div>
                        <div className="property-card-overlay">
                          <h4 className="property-card-name">Bagaincha Resort & Spa</h4>
                        </div>
                      </div>
                    </a>
                  </motion.div>

                  {/* 31 Park Hotel */}
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.3 }}
                    className="property-card"
                  >
                    <a 
                      href="https://31avenuelakeside.com" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="property-card-link"
                    >
                      <div className="property-card-image">
                        <div 
                          className="property-card-bg"
                          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/31parkhotel.jpg)` }}
                        ></div>
                        <div className="property-card-overlay">
                          <h4 className="property-card-name">31 Park Hotel</h4>
                        </div>
                      </div>
                    </a>
                  </motion.div>

                </div>
              </div>
            </motion.div>

          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Hospitality;
